import { render, staticRenderFns } from "./DpaHeader.vue?vue&type=template&id=46c89625&"
import script from "./DpaHeader.vue?vue&type=script&lang=ts&"
export * from "./DpaHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports